import Vue from 'vue'
import Router from 'vue-router'
import { routes } from './routes'
import { middleware } from '@/router/middleware'

Vue.use(Router)

export const defaultLocale = 'de'
// export const allowedLocale = `/:locale(${defaultLocale})?` // /:locale(de|en)?

export const router = new Router({
  mode: 'history',
  routes
})

router.beforeEach(middleware)

export default router
